import { COLORS } from '../../styles/colors';
import Container from 'react-bootstrap/Container';
import { Link } from '../Link';
import { LoginButton } from './components/LoginButton';
import { LogoutButton } from './components/LogoutButton';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import React from 'react';
import logo from '../../assets/ifnmu-logo.png';
import routes from '../../routes/routes';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useMeQuery } from '../../generated/graphql';

const StyledNavbar = styled(Navbar)`
    margin-bottom: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    padding: 0.75rem 0;
    background: linear-gradient(135deg, ${COLORS.primary}, ${COLORS.secondary}) !important;
`;

const NavLink = styled(Nav.Link)`
    color: rgba(255, 255, 255, 0.9) !important;
    font-weight: 500;
    padding: 0.5rem 1rem !important;
    margin: 0 0.25rem;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
        color: ${COLORS.white} !important;
        background: ${COLORS.dark};
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &.active {
        background: ${COLORS.dark};
        color: ${COLORS.white} !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

const BrandLink = styled(Navbar.Brand)`
    cursor: pointer;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;

    &:hover {
        background: ${COLORS.dark};
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

const Logo = styled.img`
    height: 40px;
    width: auto;
    object-fit: contain;
    filter: brightness(0) invert(1);
` as React.ComponentType<React.ImgHTMLAttributes<HTMLImageElement>>;

const NavContainer = styled(Container)`
    padding: 0 1.5rem;
`;

const StyledNav = styled(Nav)`
    gap: 0.5rem;
`;

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
    const { data } = useMeQuery();
    const history = useHistory();
    const isAuthorized = Boolean(data?.me?.email);
    console.log(data, 'header'); /// add more date where it is needed

    return (
        <StyledNavbar collapseOnSelect expand="lg" variant="dark">
            <NavContainer>
                <BrandLink onClick={() => history.push(routes.home)}>
                    <Logo src={logo} alt="IFNMU Logo" />
                </BrandLink>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <StyledNav className="me-auto">
                        {isAuthorized && (
                            <NavLink as={Link} href={routes.home}>
                                Ваші документи
                            </NavLink>
                        )}
                        {data?.me?.moderator && (
                            <NavLink as={Link} href={routes.moderationGroup}>
                                Сторінка модератора
                            </NavLink>
                        )}
                        {data?.me?.admin && (
                            <NavLink as={Link} href={routes.administrator}>
                                Сторінка адміністратора
                            </NavLink>
                        )}
                    </StyledNav>
                    <StyledNav>{isAuthorized ? <LogoutButton /> : <LoginButton />}</StyledNav>
                </Navbar.Collapse>
            </NavContainer>
        </StyledNavbar>
    );
};
